module.exports = __webpack_public_path__ + "static/logo-white-colored-red-subline-6656852ac5fa838ae0634d2e82247f98.svg";